import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

class Toast extends Component{
  render() {
    return (
      <Fragment>
        <div className={classNames({"error-wrapper": true,"show": this.props.show})}>{this.props.content}</div>
      </Fragment>
    )
  }
}

Toast.propTypes = {
  content: PropTypes.string.isRequired
}

export default Toast